import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ThumbsUpIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ThumbsUpIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M4.49701 8.91797C5.62865 8.91797 6.49403 9.82205 6.49403 11.0043V19.906C6.49403 21.0883 5.62865 21.9924 4.49701 21.9924C3.36537 21.9924 2.5 21.0883 2.5 19.906V11.0043C2.5 9.82205 3.36537 8.91797 4.49701 8.91797Z"
        stroke="black"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M4.52539 22H16.2971C17.9184 22 19.3282 20.9413 19.5396 19.4592L21.3724 12.3748C22.0068 9.76348 20.1741 8.84598 18.1299 8.84598H14.6195C14.408 8.84598 14.267 8.63425 14.3446 8.43663C15.7755 4.63253 14.408 2 12.9841 2C11.5602 2 11.7153 3.90558 10.8694 5.81116C9.45965 8.91656 7.62693 8.91656 7.20399 8.91656H4.52539"
        stroke="black"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </Icon>
  )
}
export default ThumbsUpIcon
